module.exports = __webpack_public_path__ + "img/interaction.439ca80d.svg";